import React from "react";
import { useLoaderData } from "react-router-dom";
import NewsCard from "../shared/NewsCard/NewsCard";

const Home = () => {
  const allnews = useLoaderData();
  return (
    <div>
      <h1>This is home: {allnews.length}</h1>
      {allnews.map((news) => (
        <NewsCard key={news._id} news={news}></NewsCard>
      ))}
    </div>
  );
};

export default Home;
